export default {
  state: {
    params: [],
    dbParams: [],
    loadedParams: [],
    queryString: '',
    showSearchField: false,
    searchFormField: {},
    popularSites: []
  },

  mutations: {
    searchParamkey: (state, queryString) => {
      queryString = queryString.toLowerCase();
      for (let i = 0; i <= state.loadedParams.length - 1; i++) {
        for (let j = 0; j <= state.loadedParams[i].form.length - 1; j++) {
          var tempArr = [];
          tempArr.push(state.loadedParams[i].form[j]);
          state.searchFormField = tempArr.find(x => x.displayName ? x.displayName.toLowerCase() == queryString : '');
          if (state.searchFormField && state.searchFormField.hasOwnProperty('key')) {
            state.showSearchField = true;
            return
          }
          if (state.loadedParams[i].form[j] && state.loadedParams[i].form[j].dependentForm) {
            for (let k = 0; k <= state.loadedParams[i].form[j].dependentForm.length - 1; k++) {
              var tempArr = [];
              tempArr.push(state.loadedParams[i].form[j].dependentForm[k]);
              state.searchFormField = tempArr.find(x => x.displayName ? x.displayName.toLowerCase() == queryString : '');
              if (state.searchFormField && state.searchFormField.hasOwnProperty('key')) {
                state.showSearchField = true;
                return
              }
            }
          }
        }
      }
      state.showSearchField = false;
      state.searchFormField = {};
      console.log("There is no result found. Refine your search string");
    }
  },
  actions: {
    searchParamkey: (context, payload) => {
      context.commit("searchParamkey", payload);
    }
  }
}